// Cache-busting update: 2026-06-01-2331
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

const redirectUri = isLocalhost ? 'http://localhost:3001/' : window.location.origin + '/';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_KTLSpDPmi',
      userPoolClientId: '5vn4m5pj2tf2j1mhq5ed5p873u',
      allowGuestAccess: true,
      loginWith: {
        oauth: {
          domain: 'dopove.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [redirectUri],
          redirectSignOut: [redirectUri],
          responseType: 'code'
        }
      }    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
